import React from "react";

interface ReportInnerNavProps {
  children: React.ReactNode;
}

const ReportInnerNav = ({ children }: ReportInnerNavProps) => {
  return (
    <div className={"inner-nav"}>
      <ul>{children}</ul>
    </div>
  );
};

export default ReportInnerNav;
